/** Shape invite API payload for ChallengeCard preview (matches wire card layout). */
export function inviteToChallengePreview(invite) {
	if (!invite) return null;

	if (invite.kind === 'household') {
		return {
			kind: 'household',
			title: invite.title,
			personal_note: invite.personal_note,
			starts_on: invite.starts_on,
			ends_on: invite.ends_on,
			status: invite.status,
			mutual_support: invite.mutual_support,
			challenger_profile: { name: invite.challenger_name },
			challenged_profile: { name: invite.challenged_name }
		};
	}

	return {
		kind: 'friend',
		title: invite.title,
		personal_note: invite.personal_note,
		starts_on: invite.starts_on,
		ends_on: invite.ends_on,
		status: invite.status,
		mutual_support: invite.mutual_support,
		challenger: {
			first_name: invite.challenger_first_name,
			full_name: invite.challenger_name
		},
		challenged: {
			first_name: invite.challenged_first_name,
			full_name: invite.challenged_name
		}
	};
}
